export default "__VITE_ASSET__CUdRQrVJ__"